import { DB_MIGRATION_LOG_EVENT } from 'src/types';
import { type AppDatabase } from '../db';
import { logger } from '../log';
import { type ItemVariant } from '../models';
import { useBusinessStore } from '../store';

const BATCH_SIZE = 500;
const CURSOR_KEY = 'v34_barcode_migration_cursor';
const COMPLETE_KEY = 'v34_barcode_migration_complete';

function migrateVariantBarcode(variant: ItemVariant): ItemVariant {
    const barcodes = variant.barcode
        ? variant.barcode
              .split(',')
              .map((b) => b.trim())
              .filter(Boolean)
        : [];
    const migrated = { ...variant, barcodes };

    return migrated;
}

export async function runBarcodeMigrationInBackground(db: AppDatabase) {
    if (localStorage.getItem(COMPLETE_KEY) === 'true') return;

    const { businessInfo } = useBusinessStore.getState();

    let lastId = localStorage.getItem(CURSOR_KEY) ?? '';
    let totalMigrated = 0;

    let batch = await db.itemVariants
        .where('id')
        .above(lastId)
        .limit(BATCH_SIZE)
        .toArray();

    while (batch.length) {
        const toMigrate = batch.filter((v) => v.barcode && !v.barcodes?.length);

        if (toMigrate.length) {
            await db.itemVariants.bulkPut(toMigrate.map(migrateVariantBarcode));
            totalMigrated += toMigrate.length;
        }

        lastId = batch[batch.length - 1].id;
        localStorage.setItem(CURSOR_KEY, lastId);

        logger.info({
            eventName: DB_MIGRATION_LOG_EVENT,
            message: `v34 barcode batch ${JSON.stringify({
                batchSize: toMigrate.length,
                totalMigrated,
                businessId: businessInfo.businessId,
                branchId: businessInfo.branchId,
            })}`,
        });

        await new Promise((r) => setTimeout(r, 50));
        batch = await db.itemVariants
            .where('id')
            .above(lastId)
            .limit(BATCH_SIZE)
            .toArray();
    }

    localStorage.setItem(COMPLETE_KEY, 'true');
    localStorage.removeItem(CURSOR_KEY);
    logger.info({
        eventName: DB_MIGRATION_LOG_EVENT,
        message: `v34 barcode migration complete ${JSON.stringify({
            totalMigrated,
            businessId: businessInfo.businessId,
            branchId: businessInfo.branchId,
        })}`,
    });
}
